import { render, staticRenderFns } from "./Guarda.vue?vue&type=template&id=65117e18&scoped=true"
import script from "./Guarda.vue?vue&type=script&lang=js"
export * from "./Guarda.vue?vue&type=script&lang=js"
import style0 from "./Guarda.vue?vue&type=style&index=0&id=65117e18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65117e18",
  null
  
)

export default component.exports